class OverlayGem extends HTMLElement {
  constructor() {
    super()

    this.closeOverlay = this.querySelectorAll('.close-modal')

    this.closeOverlay.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        const parentOverlay = closeButton.closest('overlay-gem')

        parentOverlay.classList.remove('visible')
        document.querySelector(".gem-guide__background video").style.display = "block"
        document.querySelector(".altNav").style.display = "flex"
        document.querySelector(".gem-guide__background .video-container").style.backgroundColor = "#000"
        window.scrollTo(0, 0)
      })
    })
  }
}

customElements.define("overlay-gem", OverlayGem)